import UserService from '@services/UserService';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Checkbox } from 'antd';
import React, { Component } from 'react';

import SearchComponent from './Default/Search/SearchComponent';

type Proptype = {
  idUnit?: any
  setSelectedIds: Function;
  confirmedUsers: string[];
  nonSelectedIds: string[];
  title: string;
}

type StateType = {
  curOffset?: string;
  tableUsers: any
  selectedUsers: any;
  nonSelectedUsers: any
  previousSelectedUsers: any;
}

export default class UsersModalComponent extends Component<Proptype,StateType> {
  static defaultProps ={
    title: 'table.manager.user'
  }
  private _userService: UserService;

  constructor(props: Proptype){
    super(props)
    this._userService = new UserService();

    this.state = {
      curOffset: '',
      tableUsers: [],
      selectedUsers: [],
      nonSelectedUsers: [],
      previousSelectedUsers: []
    }
  }

  UNSAFE_componentWillMount () {
    this.initialData()
  }

  initialData = async () => {
    await this.getUsers(false)

    const e = { target: { checked: true } }

    if (this.props.confirmedUsers && this.props.confirmedUsers.length > 0) {
      for (let dataRow of this.props.confirmedUsers) {
        this.returnSelectedUsersArray(e, dataRow.id)
      }
    }
  }
  
  getUsersIdArray = (usersObject: any) => {
    const userIdArray = []
    for(let singleUser of usersObject){
      userIdArray.push(singleUser.id)
    }
    return userIdArray
  }
  
  getUsers = async (reset: boolean, search?: string) => {
    const dataTableCreate: any = [];
    if(reset){
      this.setState({curOffset: undefined})
    }

    try {
        let data = await this._userService.paging({
        unit: this.props.idUnit,
        to: undefined,
        from: undefined,
        search: search,
        limit: 12,
        offset: this.state.curOffset
      });

  
      let i = 0;
      for(let singleData of data.items){
        const _tableData = {
          key: singleData.id,
          id: singleData.id,
          name: singleData.name,
          stringId: singleData.username,
          originalIndex: i
        }
        dataTableCreate.push(_tableData);
        i += 1
      }
  
      let newDataTableCreate: any = []
      if (data !== undefined) {
        if(!reset) {
          newDataTableCreate = this.state.tableUsers || [];
        }
        newDataTableCreate = newDataTableCreate.concat(dataTableCreate)
      }

      // const userIdArray = this.getUsersIdArray(newDataTableCreate)
  
      this.setState({
        tableUsers: newDataTableCreate,
        // nonSelectedUsers: userIdArray,
        nonSelectedUsers: newDataTableCreate,
        curOffset: data.offset
      });
    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  }

  loadMoreUsers = async () => {
    this.getUsers(false);
  }

  returnSelectedUsersArray = async (e: any, userId: string) => {
    let selectedUsers = this.state.selectedUsers;
    let nonSelectedUsers = this.state.nonSelectedUsers;
    const containedInSelectedUsers = nonSelectedUsers.find((user: any) => {
      if(user.id === userId){
        return true
      } else return 
    })

    if(!!containedInSelectedUsers && e.target.checked === true){
      for(let singleUser of nonSelectedUsers) {
        if(userId === singleUser.id){
          selectedUsers.push(singleUser)
          const index = nonSelectedUsers.indexOf(singleUser)
          nonSelectedUsers.splice(index, 1)
        }
      }
    }
     else if (!containedInSelectedUsers && e.target.checked === false){
      // Jogar um valor para o non selected
      const value = selectedUsers.find((currentObject: any) => currentObject.id === userId)
      nonSelectedUsers.push(selectedUsers[selectedUsers.indexOf(value)])
      // tirar o valor do selected users
      selectedUsers = selectedUsers.filter((currentValue: any) => currentValue.id !== userId)
      nonSelectedUsers.sort((a: any,b: any) => (a.originalIndex > b.originalIndex) ? 1 : ((b.originalIndex > a.originalIndex) ? -1 : 0)); 
    }

    this.setState({selectedUsers, nonSelectedUsers})
    this.props.setSelectedIds(selectedUsers, nonSelectedUsers)
  }


  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    try {
      this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };


  render() {
    return (
      <Wrapper>
        <div className="title-div">
          <h3>{I18n.l(this.props.title)}</h3>
          <p>{I18n.l('table.profile.linkUsers')}</p>
        </div>
        <ContainerBoard>
          <div className="non-selected-users">
            <h3>{I18n.l('table.manager.user')}</h3>
            <SearchComponent
              onSubmit={this.handleUsersSearch}
              placeholder='form.placeholders.productSearch'
              buttonText='form.buttons.search'
            />
            <div className="users-render">
            {this.state.nonSelectedUsers && this.state.nonSelectedUsers.length === 0 && <h1>{I18n.l('common.loadingData')}</h1>}
            {
            this.state.nonSelectedUsers &&
            this.state.nonSelectedUsers.map((user: any) => <Checkbox className="checkbox-formatting" key={`${user.key}`} onChange={(e) => this.returnSelectedUsersArray(e, user.id)}>{user.name}</Checkbox>)
            }
            </div>
            {this.state.curOffset != undefined && this.state.curOffset != null && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  // loading={loadingMoreAssigners}
                  onClick={() => this.loadMoreUsers()}
                >
                  {I18n.l('common.seeMore')}
                </Button>
              )}
          </div>
          <div className="selected-users">
          <h3>{I18n.l('common.selected.users')}</h3>
          <div style={{height: '85%'}}className="users-render">
            {
            this.state.selectedUsers &&
            this.state.selectedUsers.map((user: any) => <Checkbox className="checkbox-formatting" checked={true} key={`${user.key}`} onChange={(e) => this.returnSelectedUsersArray(e, user.id)}>{user.name}</Checkbox>)
            }
            </div>
          </div>
        </ContainerBoard>
      </Wrapper>
    )
  }
}


const Wrapper = styled.div`
width: 100%;
height: 60vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;

.selected-users{
  flex: 1;
  padding: 20px;
  border-left: 1px solid #C4C4C4;
}

.non-selected-users{
  flex: 1;
  padding: 20px;
}


.users-render{
  display: flex;
  flex-direction: column;
  margin-top: 5%;
  padding: 10px 20px;
  height: 70%;
  overflow-y: auto;
}

.title-div{
  align-self: flex-start;
  margin: 0 0 20px 40px;

  h3{
    font-size: 28px;
    color: #335D7C;
    text-transform: uppercase;
  }
  p{
    color: #7f7f7f;
    margin-left: 2px;
  }
}

.checkbox-formatting{
  font-size: 1.15em;
  margin-left: 10px;
  padding: 5px;
}
`

const ContainerBoard = styled.div`
  width: 95%;
  height: 80%;
  padding: 20;
  background-color: #F9F9F9;
  display: flex;
  flex-direction: row;
`
